import { useState, useEffect } from 'react';

interface FAQ {
  title: string;
  answer: string;
}

interface ClassroomData {
  carreer?: string;
  course?: string;
}

interface UseFAQsReturn {
  faqs: FAQ[];
  loading: boolean;
  error: string | null;
}

export const useFAQs = (classroom?: ClassroomData): UseFAQsReturn => {
  const [faqs, setFaqs] = useState<FAQ[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const fetchFAQs = async () => {
      setLoading(true);
      setError(null);
      try {
        if (!classroom?.carreer && !classroom?.course) {
          setFaqs([]);
          setLoading(false);
          return;
        }
        const params = new URLSearchParams();
        if (classroom.carreer) {
          params.append('carreer', classroom.carreer);
        } else if (classroom.course) {
          params.append('course', classroom.course);
        }
        const response = await fetch(`/api/faq?${params.toString()}`);
        if (!response.ok) {
          throw new Error('Error al cargar las Preguntas Frecuentes');
        }
        const data = await response.json();
        setFaqs(data || []);
      } catch (err: unknown) {
        console.error('Error fetching FAQs:', err);
        setFaqs([]);
      } finally {
        setLoading(false);
      }
    };
    fetchFAQs();
  }, [classroom?.carreer, classroom?.course]);
  return { faqs, loading, error };
};